import styled, { css } from 'styled-components';
import { Container } from '@/components/ui/flexbox';
import { Field } from '@/components/platform/Form/styles';
import { sword } from '@swordhealth/ui-corporate';

export const CustomContainer = styled(Container)`
  position: relative;
  z-index: 1;
  max-width: 1400px;
  display: flex;
  flex-direction: row;
  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    flex-direction: column-reverse;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.min_lg}px) {
    margin-top: ${(props) => (!props.$scrolled ? `-${props.$barHeight}px` : 0)};
  }

  ${(props) =>
    props.$hasContentRight &&
    css`
      flex-direction: row-reverse;
    `}
`;

export const Content = styled.div`
  display: grid;
  width: 50%;
  min-height: 768px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    width: 100%;
    min-height: 432px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    width: 100%;
    min-height: 180px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    justify-content: center;
  }
`;

export const Inner = styled.div`
  padding: 148px 80px 148px 0;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  position: relative;
  z-index: 1;
  gap: 24px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    padding: 64px 0;
    min-height: auto;
    width: 100%;
    margin: 0 auto;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    padding: 40px 0;
    align-items: center;
    text-align: center;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.min_lg}px) {
    justify-content: center;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
  }
`;

export const HeadingWrapper = styled.div`
  b,
  strong {
    text-rendering: optimizeSpeed;
  }
  h1.dynamic-title {
    line-height: 44px;
    @media (max-width: ${sword.breakpoints.maxMd}) {
      font-size: var(--ui-font-heading-3xl-size-md);
    }
    @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
      font-size: var(--ui-font-heading-3xl-size-sm);
      line-height: 32px;
    }
  }
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.grey.default};
  text-align: left;
  white-space: pre-line;
  margin-top: 16px;

  p {
    line-height: 20px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    text-align: center;
  }
`;

export const FixedWrapper = styled.div`
  width: 100%;
  height: 66px;
  background-color: ${(props) => props.theme.colors.neutral.default};
  text-align: center;
  padding: 10px 0;
  position: fixed;
  top: 0;
  z-index: 1;
  display: none;
  box-shadow: rgba(233, 220, 211, 0.4) 0 2px 10px 0;

  ${(props) =>
    props.$visible &&
    css`
      display: block;
    `};
`;

export const EnrollButtonWrapper = styled.div`
  position: relative;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    width: 100%;
    text-align: center;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;

  form {
    text-align: left;
    flex-direction: column !important;

    ${Field} {
      width: 100%;
    }
  }
`;
export const TitleFirstLine = styled.span`
  display: block;
  overflow: visible;
  white-space: nowrap;
  & > div {
    display: inline-block;
  }
`;
